import React from 'react'
import { TextField } from '@mui/material'

const CustomTextField = ({
  icon: Icon,
  value,
  onChange,
  placeholder,
  type,
  sx,
  ...props
}) => {
  return (
    <TextField
      {...props}
      value={value}
      onChange={onChange}
      variant='filled'
      label={placeholder}
      type={type}
      size='small'
      sx={{
        marginBottom: 4,
        width: '70%',
        '& .MuiFilledInput-root': {
          backgroundColor: 'white',

          '&:hover::before': {
            borderBottomColor: 'primary.main',
          },
          '&::after': {
            borderBottomColor: 'primary.main',
          },
        },
        '& .MuiInputLabel-root': {
          color: 'black',
          fontFamily: 'Work Sans',
          fontSize: '16px',
          fontWeight: 500,
          textAlign: 'left',
        },
        ...sx,
      }}
    />
  )
}

export default CustomTextField
